import { render, staticRenderFns } from "./intermediaryAdd.vue?vue&type=template&id=0d8d604e&scoped=true"
import script from "./intermediaryAdd.vue?vue&type=script&lang=js"
export * from "./intermediaryAdd.vue?vue&type=script&lang=js"
import style0 from "./intermediaryAdd.vue?vue&type=style&index=0&id=0d8d604e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d604e",
  null
  
)

export default component.exports